import { ErrorFallbackStyled } from './ErrorFallback.style'

export const ErrorFallback = () => (
  <ErrorFallbackStyled>
    <span>An error occured, please contact support at ico@cardashift.com</span>
  </ErrorFallbackStyled>
)
